const BOOT_RECOVERY_KEY = 'admin-boot-recovery-attempted'

function reloadOnce(): void {
  try {
    if (sessionStorage.getItem(BOOT_RECOVERY_KEY)) return
    sessionStorage.setItem(BOOT_RECOVERY_KEY, '1')
  } catch {
    // sessionStorage unavailable - still safer to reload once than leave a blank page forever
  }
  window.location.reload()
}

// Safety net: auto-reload once per tab session on a pre-mount script error. Call
// markBooted once mounted so a later, unrelated error doesn't also trigger a reload.
export function installBootFailureRecovery(): { markBooted: () => void } {
  window.addEventListener('error', reloadOnce)
  window.addEventListener('unhandledrejection', reloadOnce)

  return {
    markBooted: () => {
      window.removeEventListener('error', reloadOnce)
      window.removeEventListener('unhandledrejection', reloadOnce)
    },
  }
}
